import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';

// Leaflet Marker Icons fix (sonst fehlen sie manchmal)
import 'leaflet/dist/leaflet.css';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png'
});

const RecenterMap = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    map.setView([lat, lng], map.getZoom(), {
      animate: true
    });
  }, [lat, lng, map]);

  return null;
};

const LocationPicker = ({ latitude, longitude, setLatitude, setLongitude, readOnly = false }) => {
  const position = [latitude, longitude];

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        if (readOnly) return;
        const { lat, lng } = e.latlng;
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
      }
    });
    return null;
  };

  return (
    <MapContainer center={[latitude, longitude]} zoom={15} style={{ height: '300px', width: '100%' }}>
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapClickHandler />
      <Marker
        position={position}
        draggable={!readOnly}
        eventHandlers={readOnly ? undefined : {
          dragend: (e) => {
            const { lat, lng } = e.target.getLatLng();
            setLatitude(lat.toFixed(6));
            setLongitude(lng.toFixed(6));
          }
        }}
      />
      <RecenterMap lat={latitude} lng={longitude} />
    </MapContainer>
  );
};

export default LocationPicker;
